import React, { useState, useEffect, useRef  } from 'react';
import Flatpickr from 'react-flatpickr';
import 'flatpickr/dist/themes/material_blue.css'; // You can choose a theme
import { Box, Typography } from '@mui/material';


function MyDatePicker({handleSelectDate, handleClose}) {
  const [selectedDate, setSelectedDate] = useState(new Date()); // State to hold the selected date
  const inputRef = useRef(null);

  
  const handleDateSelect = (selectedDates) => {
    const selectedDate = selectedDates[0]; // Get the selected date
    selectedDate.setHours(0, 0, 0, 0); 
    const isoString = selectedDate.toISOString()
    setSelectedDate(selectedDate);
    handleSelectDate(isoString)
  };

  const handleInputFocus = () => {
    if (selectedDate) {
      inputRef.current.flatpickr.open(); // Open the Flatpickr calendar when the input is focused
    }
  };


  return (
    <Box sx={{
      display:'flex', 
      // flexDirection:'column',
      justifyContent:'space-between',
      alignItems:'center',
      marginTop:"0rem",
      paddingTop:"0rem",
      width:'100%'
      
      }}>
    {/* Display data related to the selected date */}
    {selectedDate && <Typography>{selectedDate.toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' })}</Typography>}
      <Flatpickr
      ref = {inputRef}
        options={{
          dateFormat: 'F j, Y', // Set the date format
          defaultDate: selectedDate, // Set the default date to the initial selected date
          onClose: handleDateSelect,
        }}
        onChange={()=>{}}
        onClose={() => {}}
        onFocus={handleInputFocus}
      />
    </Box>
  );
}

export default MyDatePicker;
